import * as React from 'react';
import '../../../../../../../context/actions.js';
import '../../../../../../../context/reducer.js';
import { useProductData } from '../../../../../../../context/product-context-hooks.js';
import '../../../../../../../context/ProductContext.js';
import '../../../../../../../context/CmsContext.js';
import '../../../../../../../hooks/useCartDiscountsQuery/types.js';
import { useCartDiscountsQuery } from '../../../../../../../hooks/useCartDiscountsQuery/use-cart-discounts-query.js';
import '../../../../../../../hooks/use-product-view-history.js';
import '@grandvisionhq/frk-routing';
import '../../../../../../../types/product.js';
import { isSubscriptionPurchase } from '../../../../../../../types/typeguards.js';
import '@swc/helpers';
import '@grandvisionhq/state';
import 'classnames';
import '@grandvisionhq/common';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/utils';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/forms';
import '@grandvisionhq/analytics';
import '@grandvisionhq/svc-tealium/events';
import '@grandvisionhq/graphql';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/inventory';
import '@grandvisionhq/lib-utils-html';
import '../../../../../../VTO/context/VtoProvider.js';
import 'usehooks-ts';
import 'use-onclickoutside';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/lib-visuals';
import '../../../../../../../slots/context.js';
import '@grandvisionhq/content';
import { useCLEcommContext } from '../../../../context/CLEcommContext.js';
import { PricedAddToCartCTA } from '../PricedAddToCartCTA/PricedAddToCartCTA.js';

const CLAddToCartCTA = ({ className , lineItemDrafts  })=>{
    const { displayPrice , activeVariant  } = useProductData();
    const { promotionIdentifier  } = activeVariant;
    const { state , selectors  } = useCLEcommContext();
    const totalSelectedQuantity = selectors.getEnabledSelectedQuantity(state);
    const { activeDiscount  } = useCartDiscountsQuery(promotionIdentifier, totalSelectedQuantity || undefined);
    const isLoading = selectors.hasQueryLoading(state);
    const totalPrice = selectors.getTotalPurchasePrice(state, displayPrice, activeDiscount);
    const { purchaseType  } = state.configurations;
    const { deliveryInterval  } = state.configurations.subscriptionPurchaseConfigurations;
    const priceInterval = isSubscriptionPurchase(purchaseType) && !!deliveryInterval ? deliveryInterval : undefined;
    return /*#__PURE__*/ React.createElement(PricedAddToCartCTA, {
        className: className,
        lineItemDrafts: lineItemDrafts,
        price: totalPrice,
        isCentAmount: false,
        priceInterval: priceInterval,
        isLoading: isLoading
    });
};

export { CLAddToCartCTA };
//# sourceMappingURL=CLAddToCartCTA.js.map
